import { Card, Box, Typography, Skeleton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const InfoCard = ({ title, icon, value, bgColor, isLoading, onClick, description }) => {
  return (
    <Box
      sx={{ border: `1px solid #e5e7eb`, borderRadius: 2, p: 2, bgcolor: bgColor }}
      className={[
        'flex items-center justify-between gap-2 ',
        isLoading ? 'cursor-not-allowed' : '',
        onClick ? 'cursor-pointer ' : ''
      ].join(' ')}
      onClick={isLoading ? null : onClick}
    >
      <div>
        <Typography
          variant='caption'
          className='uppercase '
          sx={{ color: '#7c828d', fontWeight: 600, fontSize: '0.7rem' }}
        >
          {title}
        </Typography>
        <Typography variant='h2' fontWeight='700' sx={{ color: '#111827' }}>
          {!isLoading ? value !== undefined ? value : '0' : <Skeleton width={30} height={60} />}
        </Typography>
        {description && (
          <Typography variant='body2' sx={{ color: '#7c828d', fontWeight: 500, fontSize: '0.8rem' }}>
            {description}
          </Typography>
        )}
      </div>
      {icon && <FontAwesomeIcon icon={icon} size='3x' className='mr-4 text-muted' />}
    </Box>
  )
}

export default InfoCard
